import { useToastedMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { CredentialLoginRequest, CredentialLoginResponse } from '../../../../shared/types/routes/auth/v2';

/**
 * Authenticates an identifier (email or username) + password against the chosen org via
 * `POST /api/auth/login/credentials`. The backend picks the credential strategy from the org's
 * configuration. No toast is wired here — the form renders credential failures inline and reserves
 * toasts for unexpected errors.
 */
export function useCredentialLogin() {
  return useToastedMutation({
    mutationFn: async (body: CredentialLoginRequest & { next?: string }) =>
      (await post<CredentialLoginRequest & { next?: string }, CredentialLoginResponse>(
        '/api/auth/login/credentials',
        body,
      )).data,
  });
}
